module.exports = __webpack_public_path__ + "img/YellowQuestionMark.3bd4ab24.svg";